<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="指派类型" prop="type" :required="true">
                <el-col :span="10">
                    <el-radio-group :value="ruleForm.type" @change="handleType">
                        <el-radio :label=1 v-if="tagsActive == 1">统一指派</el-radio>
                        <el-radio :label=2>分任务指派</el-radio>
                    </el-radio-group>
                    <el-button style="margin-left: 20px;" type="primary" size="mini" v-if="ruleForm.type == 2 && getCurAuth('batch_work_order_assign') && tagsActive == 1" @click="handleSettle">批量指派</el-button>
                </el-col>
            </el-form-item>
            <el-form-item label="" v-if="ruleForm.type == 1">
                <p style="margin:0;padding:6px 10px;background:#f5f7fa;border-left:3px solid #409EFF;font-size:13px;width:600px;">
                    排单定版制作部门：<span style="color:#409EFF;">{{ schedulingGroupName || '-' }}</span>
                </p>
            </el-form-item>
            <el-form-item label="选择制作人" prop="producer_uids" v-if="ruleForm.type == 1" :required="true">
                <JtCascader
                    popper-class="cascader-list-height-360"
                    v-model="ruleForm.producer_uids"
                    :options="producer_options"
                    clearable
                    filterable
                    :props="{ multiple: true, emitPath:false }"
                    :filter-method="filterMethod"
                    @change="handleChange"
                    style="width: 600px;"
                ></JtCascader>
            </el-form-item>
            <el-form-item label="设置完成时间" prop="set_date_type" v-if="ruleForm.type == 1" :required="true">
                <el-radio-group v-model="ruleForm.set_date_type">
                    <el-radio :label=1>按照期望日期指派</el-radio>
                    <el-radio :label=2>指定日期指派</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="" prop="finish_time" v-if="ruleForm.type == 1 && ruleForm.set_date_type == 2">
                <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.finish_time"
                value-format="yyyy-MM-dd" clearable size="mini" style="width: 360px;" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import {settleModel} from './modal'
import {JtCascader } from '@/components/Ele';
import {wordToPinyin} from '@/utils';
export default {
    name: 'assignInfo_set',
    props:['pageFuncNames','producer_options', 'multipleSelection', 'tagsActive', 'schedulingGroupName'],
    components:{
        JtCascader
    },
    data() {
        return {
            ruleForm: {
                type: 1,
                set_date_type: 1,
                finish_time:'',
                producer_uids:[]
            },
            rules:{
                producer_uids:[{
                    required: true,
                    message: '必填项不可为空',
                    trigger: 'change'
                }]
            },
            options: [],
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() < (Date.now()-(24 * 60 * 60 * 1000));
                },
            }
        }
    },
    watch:{
        'tagsActive': {
          handler(n) {
              this.ruleForm.type = Number(n)
          },
          immediate:true
        },
      'ruleForm.set_date_type' :{
          handler(n) {
              this.$emit('batch-click', this.ruleForm)
          }
      },
      'ruleForm.producer_uids':{
          handler(n) {
              // this.ruleForm.completion_date
              this.$emit('batch-click', this.ruleForm)
          }
      },
      'ruleForm.finish_time':{
          handler(n) {
              this.$emit('batch-click', this.ruleForm)
          }
      }
    },
    mounted() {
        this.$emit('batch-click', this.ruleForm)


    },
    methods:{
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        handleChange(value) {
            console.log('value',value)
        },
        filterMethod(node, keyword){
            let py = wordToPinyin(node.label);
            let allStr = py.join('');
            let capStr = py.map(item=>item[0]).join('');
            return allStr.includes(keyword)||capStr.includes(keyword)||node.text.includes(keyword);
        },
        handleType(value) {
            this.$confirm('更改指派类型后内容不保存，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ruleForm.type = value == 1 ? 2 : 1

                this.$emit('radio-click', this.ruleForm.type)

                if(this.ruleForm.type == 2) {
                    this.ruleForm.producer_uids = []
                    this.ruleForm.set_date_type = 1
                    this.ruleForm.finish_time = ''
                }
                if(this.ruleForm.type == 1) {
                    this.$emit('batch-click', this.ruleForm)
                }
            }).catch(() => {
                this.ruleForm.type = value == 2 ? 2 : 1

                this.$emit('radio-click', this.ruleForm.type)

                if(this.ruleForm.type == 1) {
                    this.$emit('batch-click', this.ruleForm)
                }
            });
        },
        // 批量指派数量
        handleSettle() {
            if(this.multipleSelection.length == 0) {
                return this.$message.error('请选择要批量指派的任务')
            }
            const {vm} = settleModel(
                {
                    props: {
                        producer_options:this.producer_options,
                        multipleSelection:this.multipleSelection,
                        tagsActive: this.tagsActive,
                        schedulingGroupName: this.schedulingGroupName
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('触发详情关闭',data);
                            if(this.ruleForm.type == 2) {
                                this.$emit('batch-click', data)
                            }
                            vm.close()
                        },
                    }
                }
            )
        }
    }
}
</script>
<style lang="scss">
.el-cascader-filter-name{
    .el-cascader__tags{
        align-items: center;
        flex-wrap: nowrap;
    }
    .el-tag--info{
        &:first-child{
            span{
                display: inline-block;
                max-width: 60px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .el-cascader__search-input{
        min-width: 20px;
        font-size: 12px;
    }
}
</style>
